import { Formulary } from "capitalrx-types";
import { request } from "./request";

export async function getFormulary(enrollmentPlanId: number): Promise<Formulary> {
  return await request({
    url: "/formulary/get",
    method: "POST",
    data: {
      id: enrollmentPlanId,
    },
  });
}
